import { formatCount } from "./traffic";
import { PAGE_SIZES } from "./usePage";
import { Pagination, Select, TableFooter } from "@/ui";

interface Props {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
  pageSize: number;
  onPageSize: (size: number) => void;
  /** 这一页（后端分页）或全部（前端分页）的行数，用来判断要不要显示分页栏。 */
  count: number;
  /** 查询到的记录总数：前端切页的列表自己知道，后端分页的列表从 count 接口取（决策 D182）；不传就不显示。 */
  total?: number;
  /** 总数数到上限就停了（消息列表封顶 10,000 条，决策 D182），显示“超过 N 条”。 */
  capped?: boolean;
  /** 总数的单位，缺省“条”；消息列表不聚合重投时行是尝试、总数仍数消息，写“条消息”（决策 D187）。 */
  unit?: string;
}

const SIZE_OPTIONS = PAGE_SIZES.map((n) => ({ value: String(n), label: `每页 ${n} 条` }));

/** 表格底部的分页栏（#133），直接接收分页 hook 的返回值：左边选每页行数、知道总数时显示“共 N 条”，右边翻页。
 * 只有一页且行数不超过最小的每页行数时不显示每页行数与页码（选了也没有意义），这时知道总数就只显示总数，不知道整行不显示。 */
export function Pager({ page, pageCount, onChange, pageSize, onPageSize, count, total, capped, unit = "条" }: Props) {
  const controls = pageCount > 1 || count > PAGE_SIZES[0];
  if (!controls && total === undefined) return null;
  return (
    <TableFooter
      left={<>
        {controls && <Select size="sm" width={120} ariaLabel="每页行数" options={SIZE_OPTIONS} value={String(pageSize)} onChange={(v) => onPageSize(Number(v))} />}
        {total !== undefined && <span>{capped ? "超过" : "共"} <span className="ax-num">{formatCount(total)}</span> {unit}</span>}
      </>}
      right={pageCount > 1 && <Pagination page={page} pageCount={pageCount} onChange={onChange} />}
    />
  );
}
